import Image from "next/image";
import Link from "next/link";
import { ExtendedRecordMap } from "notion-types";
import React from "react";
import { NotionRenderer } from "react-notion-x";
import "react-notion-x/src/styles.css";

export const ContentRender: React.FC<{
  recordMap: ExtendedRecordMap;
}> = ({ recordMap }) => {
  return (
    <NotionRenderer
      className="!bg-transparent !px-0"
      recordMap={recordMap}
      darkMode={false}
      isImageZoomable={false}
      components={{
        nextImage: Image,
        nextLink: Link,
      }}
    />
  );
};
